import { createFileRoute } from '@tanstack/react-router';
import { ChainCourseListPage } from '@/pages/chain/courses/ChainCourseListPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { z } from 'zod';

const searchSchema = z.object({
	page: z.number().optional(),
	limit: z.number().optional(),
	search: z.string().optional(),
	status: z.enum(['DRAFT', 'PUBLISHED', 'CANCELLED', 'COMPLETED']).optional(),
	type: z.enum(['COURSE', 'WEBINAR']).optional(),
	categoryId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/chain/courses/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['courses.read', 'courses.author'], redirectTo: '/dashboard' }),
	validateSearch: searchSchema,
	component: ChainCourseListPage,
});
